import AutoTSMenuLayout from '../../components/AutoTSMenuLayout'

/**
 * @param {{
 *  children: React.ReactNode
 *  filters: React.ReactNode
 * }} props
 */
export default function LayoutPPR({ dataTest, children, ...props }) {
  return (
    <AutoTSMenuLayout
      subtitle="Project Performance Rating"
      breadcrumbLabel="Project performance rating"
      showLearnMorePpr={true}
      info='ppr'
      dataTest={dataTest}
      {...props}
    >
      {children}
    </AutoTSMenuLayout>
  )
}
